import { Type } from "class-transformer";
import { AuthSecondFactor } from "./AuthSecondFactor";
import { PasswordRules } from "./PasswordRules";

export class AuthRules {
    userNameIsEmail = false;
    anonymousOnly = false;
    canRegister = false;
    canRevokePassword = false;
    canRevokePasswordSelf = false;
    revokePasswordPerEmailIfSet = true;
    canChangePassword = false;
    revokePasswordMessage: string;
    revokePasswordAfterMessage: string;
    useRecoveryQuestions = false;
    minRecoveryQuestions = 3;
    correctRecoveryQuestions = 3;
    @Type(() => PasswordRules)
    passwordRules: PasswordRules = new PasswordRules();
    authQuestions: string[];
    secondFactor: AuthSecondFactor = AuthSecondFactor.none;
}
